import useTlmCart from '~/composable/useTlmCart';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomer from '~/composable/customer/useCustomer';
import { VALIDATION_STATUS } from '~/constants/ValidationStatus';
import { CUSTOMER_TYPE } from '~/constants/CheckoutFlow';
export default function cashFlowHandler () {
  const validValidationPromise = () => {
    return Promise.resolve({
      actionStatus: VALIDATION_STATUS.VALID,
      signupBlockingNotifications: [],
      hasSignupBlockingNotification: false
    });
  }
  const initialize = () => {
    return true;
  }

  const preValidate = () => {
    return validValidationPromise();
  }

  const validate = () => {
    return validValidationPromise();
  }

  const execute = () => {
    return validValidationPromise();
  }

  const finalize = () => {
    return validValidationPromise();
  }

  const finalizeStep = async(stepType, state, appContext) => {
    const customerDetails = state.customerInfo.customerDetails
    const { menu } = state.customerInfo
    const { addAddressInformation } = useCustomer(appContext)
    const { getCartID } = useTlmCart(appContext)
    switch (stepType) {
      case STEP_TYPE.CUSTOMER_INFO:
        if (CUSTOMER_TYPE.PRIVATE === menu.value) {
          await addAddressInformation({
            useBillingAddressAsShipping: true,
            shippingAddress: customerDetails.value.addressDTO,
            billingAddress: customerDetails.value.addressDTO,
            emailAddress: customerDetails.value.email,
            cvrNumber: customerDetails.value.cvrNumber,
            cartID: getCartID.value,
            emptyCvrCprInCart: true
          })
        }
        break;
      case STEP_TYPE.CONFIRMATION:
        break;
      default:
        return true;
    }
  }
  return {
    initialize,
    preValidate,
    validate,
    finalize,
    execute,
    finalizeStep
  }
}
